import React from 'react';
import { Link } from 'react-router-dom';
import { SIGNIN_ADMIN } from '../../routes';
import { withStyles, useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import ButtonBase from '../Buttons/ButtonBase';

const lawyerVerificationEmail = '/img/admin/enviar-correo.svg';

const styles = () => ({
  img: {
    position: 'absolute',
    left: '50%',
    top: 8,
    transform: 'translate(-50%)'
  },
  title: { 
    backgroundColor: '#c1c1c1',
    height: 100
  },
  content: {
    marginTop: 60,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  actions: {
    padding: 32,
    textAlign: 'center',
    margin: '0 auto'
  },
  noticeText: {
    fontWeight: 'bold',
    width: 290,
    margin: '0 auto',
    lineHeight: 1.2
  },
  contentText: {
    width: 300,
    fontSize: 12,
    lineHeight: 1.2
  }
});

function ReusableModal(props) {
  const { 
    classes,
    styleSheet,
    noticeText,
    email,
    handleClick,
    instructions,
    instructionDetails
  } = props;

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      fullScreen={fullScreen}
      maxWidth="xs"
      disableEscapeKeyDown
      open={true}
      onClose={handleClick}
      aria-labelledby="dialog-title"
      aria-describedby="dialog-description"
    >
      <DialogTitle id="dialog-title" className={`${styleSheet.title} ${classes.title}`}>
        <img
          src={lawyerVerificationEmail}
          alt="Contacta Abogado Verificación de Correo Electrónico"
          className={`${styleSheet.img} ${classes.img}`}
        />
      </DialogTitle>
      <DialogContent className={`${styleSheet.content} ${classes.content}`}>
        <div>
          <Typography
            className={classes.noticeText}
            variant="h6"
            color="primary"
            align="center"
            paragraph
          >
            {noticeText}
          </Typography>
          <DialogContentText
            id="dialog-description"
            align="center"
            className={classes.contentText}
            paragraph
          >
            <br />
            {instructions}
            <br />
            <br />
            <span style={{ fontSize: 18 }}>{email}</span>
            <br />
            <br />
            {instructionDetails}
          </DialogContentText>
        </div>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <Link to={SIGNIN_ADMIN}>
            <ButtonBase
                type="button"
                variant="primary"
                autoFocus
                onClick={handleClick}
            >
                Entendido
            </ButtonBase>
        </Link>
      </DialogActions>
    </Dialog>
  );
}

export default withStyles(styles)(ReusableModal);
